export default __webpack_public_path__ + "static/media/logo-union.05c86f1b.png";